import type { Interceptor } from '../types'

export interface AuthInterceptorConfig {
  tokenSource: () => Promise<string | undefined>
  useBearerPrefix?: boolean
}

export const AUTH_INTERCEPTOR_NAME = 'auth'

export function createAuthInterceptor(config: AuthInterceptorConfig): Interceptor {
  const useBearer = config.useBearerPrefix !== false
  return {
    name: AUTH_INTERCEPTOR_NAME,
    order: 10,
    handler: async (ctx, next) => {
      const token = await config.tokenSource()
      if (token) {
        const value = useBearer ? `Bearer ${token}` : token
        ctx.request.headers = {
          ...ctx.request.headers,
          Authorization: value,
        }
      }
      await next()
    },
  }
}
